<template>
  <NuxtLink :to="link" class="px-5 lg:px-6 py-4 lg:py-3 text-2xl lg:text-xl"><slot /></NuxtLink>
</template>

<script setup lang="ts">
import { getStoryblokLink, parseStoryblokFullSlug } from '~/composables/storyblokLink';
import type { SbLink } from '~/types/StoryBlok';

const props = defineProps<{ to: string | SbLink }>();
const link = computed(() =>
  typeof props.to === 'string' ? parseStoryblokFullSlug(props.to) : getStoryblokLink(props.to),
);
</script>

<style scoped></style>
